<template>
  <el-dialog class="time-log-form-modal" :title="modalTitle" :visible.sync="formModalOpened" :before-close="close">
    <el-form
      ref="timeLogForm"
      :model="formData"
      :rules="rules"
      label-width="120px"
      v-loading="creating || updating"
    >
      <el-form-item prop="category_id" label="Category">
        <el-select v-model.lazy.trim="formData.category_id" placeholder="Select category">
          <el-option
            v-for="(category, index) in categories"
            :key="index"
            :label="category.name"
            :value="category.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="started_at" label="Start time">
        <el-date-picker
          v-model="formData.started_at"
          type="datetime"
          placeholder="Select date and time"
          format="MM/dd/yyyy hh:mm:ss a">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="stopped_at" label="End time">
        <el-date-picker
          v-model="formData.stopped_at"
          type="datetime"
          placeholder="Select date and time"
          format="MM/dd/yyyy hh:mm:ss a">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="note" label="Note">
        <el-input type="textarea" v-model.lazy="formData.note" placeholder="Your note..."></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <el-button type="primary" @click="submitForm()">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import { mapActions, mapGetters } from 'vuex';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';
  import formPopulator from '@/mixins/form_populator';
  import TimePicker from '@/components/TimePicker';

  export default {
    name: 'TimeLogFormModal',
    mixins: [formPopulator],
    components: {
      timePicker: TimePicker,
    },
    data() {
      return {
        loadingCategories: false,
        formData: {
          category_id: '',
          note: '',
          started_at: '',
          stopped_at: '',
        },
        rules: {
          category_id: [
            { type: 'integer', required: true, message: 'Please provide category', trigger: 'blur' },
          ],
          started_at: [
            { type: 'object', required: true, message: 'Please provide start time', trigger: 'click' },
          ],
          stopped_at: [
            { type: 'object', required: true, message: 'Please provide end time', trigger: 'click' },
          ],
        },
        pickerOptions: {
          disabledDate(date) {
            return moment().isBefore(date);
          },
        },
      };
    },
    created() {
      this.loadingCategories = true;
      this.fetchCategories({ type: 'BillingCategory' })
        .then(() => {
          this.loadingCategories = false;
        });
    },
    computed: {
      ...mapGetters('entities/timeLogs', ['creating', 'currentEntity', 'formModalContext']),

      formModalOpened: {
        get() {
          return this.$store.getters['entities/timeLogs/formModalOpened'];
        },
        set(newValue) {
          if (!newValue) {
            this.closeFormModal();
          }
        },
      },
      modalTitle() {
        return this.currentEntity ? 'Edit Time Log' : 'Add Time Log Entry';
      },
      categories() {
        return this.$store.getters['entities/categories/query']()
          .where('type', 'BillingCategory')
          .get();
      },
      updating() {
        return this.currentEntity ? this.$store.getters['entities/timeLogs/isUpdating'](this.currentEntity.id) : false;
      },
    },
    methods: {
      ...mapActions('entities/timeLogs', ['updateTimeLog', 'createTimeLog', 'closeFormModal']),
      ...mapActions('entities/categories', ['fetchCategories']),

      resetForm() {
        this.$refs.timeLogForm.resetFields();
      },
      clearForm() {
        this.resetForm();
        this.formData = {
          category_id: '',
          note: '',
          started_at: '',
          stopped_at: '',
        };
      },
      submitForm() {
        this.$refs.timeLogForm.validate((valid) => {
          if (valid) {
            if (this.currentEntity) {
              this.updateTimeLog({ id: this.currentEntity.id, data: this.formData })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Time log has been edited successfully');
                    this.closeFormModal();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            } else {
              this.createTimeLog(this.formData)
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Time log has been created successfully');
                    this.closeFormModal();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            }
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));
            return false;
          }
          return true;
        });
      },
      close() {
        this.closeFormModal();
        this.clearForm();
      },
    },
    watch: {
      currentEntity: {
        handler(newObject) {
          if (newObject) {
            this.populateFormWithModel(newObject, 'formData');
          } else {
            this.clearForm();
          }
        },
        deep: true,
      },
    },
  };
</script>

<style lang="scss">
  .time-log-form-modal {
    .line {
      text-align: center;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/timeLog/TimeLogFormModal.vue